import { useCallback } from "react";
import Toast from "@moltech/molui/toast";
import { usePostDataMutation } from "../../app/services/commonApi";
import { usePostFileDataMutation } from "../../app/services/fileUploadApi";
import { pick } from "./copilotUtils";

export const useCopilotAttachments = ({ ensureActiveThread, setThreadAttachments }) => {
  const [uploadFile, { isLoading: isUploading }] = usePostFileDataMutation();
  const [postData] = usePostDataMutation();

  const handleAttachFiles = useCallback(
    async (files) => {
      const current = ensureActiveThread();
      try {
        const formData = new FormData();
        const batchName = `MolAssist_${Date.now()}`;
        formData.append("BatchName", batchName);
        files.forEach((f) => formData.append("Files", f));

        await uploadFile({
          url: "/ManageApplicants/UploadApplicantResumes",
          data: formData,
        }).unwrap();

        const listResp = await postData({
          url: "/ManageApplicants/GetAllApplicantResume",
          data: {
            pageNumber: 1,
            pageSize: 5,
            sortField: "ApplicantResumeId",
            sortOrder: -1,
          },
        }).unwrap();

        const rows =
          pick(listResp, "data", "Data")?.data ||
          pick(listResp, "data", "Data")?.items ||
          pick(listResp, "data", "Data") ||
          [];

        const latest = Array.isArray(rows) ? rows[0] : null;
        const resumeId = pick(latest, "applicantResumeId", "ApplicantResumeId");

        const nextAttachments = [
          ...(current.attachments || []),
          {
            type: "resume",
            applicantResumeId: resumeId ? Number(resumeId) : null,
            fileName: files[0]?.name,
          },
        ].filter((a) => a.applicantResumeId || a.fileName);

        setThreadAttachments(current.id, nextAttachments);
        Toast.success("Resume attached. Ask me to read it or create a candidate.");
      } catch (err) {
        Toast.error(err?.data?.message || err?.message || "Upload failed.");
      }
    },
    [ensureActiveThread, postData, setThreadAttachments, uploadFile]
  );

  return { handleAttachFiles, isUploading };
};
